export default __webpack_public_path__ + "static/media/jgla.3bfc2ac0.jpeg";